<template>
  <transition name="modal">
    <div class="modal" v-if="activeModal==='map'">
      <div class="modal__dialog">
        <i class="modal__close close" @click="closeModal" />
        <div class="modal__content">
          <div class="modal__map map">
            <gmap-map class="map__canvas" :center="position" :options="mapOptions"
              :zoom="16">
              <gmap-marker :icon="iconMarker" :position="position" :clickable="true"
                :draggable="true" />
            </gmap-map>
          </div>
        </div>
      </div>
      <i class="modal__backdrop" @click="closeModal" />
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MapModal',
  data() {
    return {
      mapOptions: {
        styles: [
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [
              {
                color: '#e9e9e9'
              },
              {
                lightness: 17
              }
            ]
          },
          {
            featureType: 'landscape',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5'
              },
              {
                lightness: 20
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 17
              }
            ]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 29
              },
              {
                weight: 0.2
              }
            ]
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 18
              }
            ]
          },
          {
            featureType: 'road.local',
            elementType: 'geometry',
            stylers: [
              {
                color: '#ffffff'
              },
              {
                lightness: 16
              }
            ]
          },
          {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f5f5f5'
              },
              {
                lightness: 21
              }
            ]
          },
          {
            featureType: 'poi.park',
            elementType: 'geometry',
            stylers: [
              {
                color: '#dedede'
              },
              {
                lightness: 21
              }
            ]
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [
              {
                visibility: 'on'
              },
              {
                color: '#ffffff'
              },
              {
                lightness: 16
              }
            ]
          },
          {
            elementType: 'labels.text.fill',
            stylers: [
              {
                saturation: 36
              },
              {
                color: '#333333'
              },
              {
                lightness: 40
              }
            ]
          },
          {
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off'
              }
            ]
          },
          {
            featureType: 'transit',
            elementType: 'geometry',
            stylers: [
              {
                color: '#f2f2f2'
              },
              {
                lightness: 19
              }
            ]
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#fefefe'
              },
              {
                lightness: 20
              }
            ]
          },
          {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#fefefe'
              },
              {
                lightness: 17
              },
              {
                weight: 1.2
              }
            ]
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['activeModal', 'activeMap']),
    iconMarker() {
      return require('@/assets/img/icon--marker.png')
    },
    position() {
      return {
        lat: Number(this.activeMap.lat),
        lng: Number(this.activeMap.lng)
      }
    }
  },
  methods: {
    ...mapActions(['openModal', 'closeModal'])
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/MapModal.vue